// Parse error function
export function parseError(error) {
  let result = {};
  result["title"] = error.title;
  result["status"] = error.status;
  result["message"] = "";

  console.log(error.errors);

  if (!error.errors) result["message"] = error.detail;
  else {
    Object.keys(error.errors).map((key) => {
      result["message"] += key + ": " + error.errors[key][0] + "\n";
    });
  }
  return result;
}

export function formatError(errorResult) {
  return (
    "(" +
    errorResult["status"] +
    ") " +
    errorResult["title"] +
    "\n - ERRORS - \n" +
    errorResult["message"]
  );
}
